import React from 'react';
import PropTypes from 'prop-types';

const HomeBuyingJourneyIcon = ({
  dashArray,
  dashOffset,
  opacity,
  showStar,
}) => {
  return (
    <svg
      width="192"
      height="192"
      viewBox="0 0 192 192"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_7014_191829)">
        <circle cx="96" cy="92" r="80" fill="white" />
        <circle
          cx="96"
          cy="92"
          r="77"
          stroke={showStar ? '#E4E5E7' : 'white'}
          strokeWidth="6"
        />
      </g>
      <circle
        className="progressBar"
        cx="96"
        cy="92"
        r="77"
        fill="transparent"
        strokeWidth="6"
        stroke="#FFC50A"
        strokeDasharray={dashArray || ''}
        strokeDashoffset={dashOffset || ''}
        strokeLinecap="butt"
      />
      <circle cx="96" cy="92" r="65" fill="#E2F7FF" />
      <g opacity={opacity} clipPath="url(#clip0_7014_191829)">
        <path
          d="M96.8465 135.002C118.853 135.002 136.693 117.162 136.693 95.1551C136.693 73.1485 118.853 55.3086 96.8465 55.3086C74.8399 55.3086 57 73.1485 57 95.1551C57 117.162 74.8399 135.002 96.8465 135.002Z"
          fill="#352269"
        />
        <path
          d="M100.154 131.693C122.16 131.693 140 113.853 140 91.8465C140 69.8399 122.16 52 100.154 52C78.147 52 60.3071 69.8399 60.3071 91.8465C60.3071 113.853 78.147 131.693 100.154 131.693Z"
          fill="#0075C9"
        />
        <path
          d="M100.153 122.494C117.08 122.494 130.801 108.773 130.801 91.8468C130.801 74.9206 117.08 61.1992 100.153 61.1992C83.2273 61.1992 69.5059 74.9206 69.5059 91.8468C69.5059 108.773 83.2273 122.494 100.153 122.494Z"
          fill="#FFC50A"
        />
        <path
          d="M113.125 76.3599L94.3782 85.1862C93.9822 85.3725 93.6562 85.6986 93.4699 86.0945L84.6436 104.842C83.8984 106.449 85.5518 108.102 87.1587 107.357L105.906 98.5305C106.302 98.3442 106.628 98.0181 106.814 97.6222L115.641 78.875C116.386 77.2681 114.732 75.6147 113.125 76.3599V76.3599Z"
          fill="#352269"
        />
        <path
          d="M100.154 95.153C101.98 95.153 103.461 93.6724 103.461 91.846C103.461 90.0196 101.98 88.5391 100.154 88.5391C98.3273 88.5391 96.8467 90.0196 96.8467 91.846C96.8467 93.6724 98.3273 95.153 100.154 95.153Z"
          fill="#8D83BE"
        />
        <path
          d="M100.829 65.3438H100.806C99.8411 65.3438 99.0591 66.1257 99.0591 67.0904V72.5865C99.0591 73.5511 99.8411 74.3331 100.806 74.3331H100.829C101.794 74.3331 102.576 73.5511 102.576 72.5865V67.0904C102.576 66.1257 101.794 65.3438 100.829 65.3438Z"
          fill="#352269"
        />
        <path
          d="M126.656 92.5238V92.5005C126.656 91.5359 125.874 90.7539 124.909 90.7539H119.413C118.448 90.7539 117.666 91.5359 117.666 92.5005V92.5238C117.666 93.4885 118.448 94.2705 119.413 94.2705H124.909C125.874 94.2705 126.656 93.4885 126.656 92.5238Z"
          fill="#352269"
        />
        <path
          d="M99.4781 118.348H99.5014C100.466 118.348 101.248 117.566 101.248 116.601V111.105C101.248 110.14 100.466 109.358 99.5014 109.358H99.4781C98.5135 109.358 97.7315 110.14 97.7315 111.105V116.601C97.7315 117.566 98.5135 118.348 99.4781 118.348Z"
          fill="#352269"
        />
        <path
          d="M73.6514 91.1715V91.1948C73.6514 92.1594 74.4334 92.9414 75.398 92.9414H80.8941C81.8587 92.9414 82.6407 92.1594 82.6407 91.1948V91.1715C82.6407 90.2068 81.8587 89.4249 80.8941 89.4249H75.398C74.4334 89.4249 73.6514 90.2068 73.6514 91.1715Z"
          fill="#352269"
        />
      </g>
      {showStar && <circle cx="96" cy="19" r="15" fill="#FFC50A" />}
      <path
        d="M94.064 16.621L95.4667 13.7787C95.6501 13.4071 96.18 13.4071 96.3634 13.7787L97.7661 16.621L100.902 17.0762C101.312 17.1357 101.476 17.6397 101.179 17.929L98.9103 20.1415L99.4459 23.2655C99.5159 23.674 99.0871 23.9855 98.7203 23.7925L95.9151 22.317L93.1098 23.7925C92.743 23.9855 92.3142 23.674 92.3842 23.2655L92.9198 20.1415L90.651 17.929C90.3543 17.6397 90.5181 17.1357 90.9282 17.0762L94.064 16.621Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_7014_191829"
          x="0"
          y="0"
          width="192"
          height="192"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7014_191829"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7014_191829"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_7014_191829">
          <rect
            width="83"
            height="83"
            fill="white"
            transform="translate(57 52)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

HomeBuyingJourneyIcon.propTypes = {
  percentage: PropTypes.string,
};

HomeBuyingJourneyIcon.defaultProps = {
  percentage: '0%',
};

export default HomeBuyingJourneyIcon;
